import useAuthStore from "@/store/useAuthStore";
import { PAGE_URL } from "@/utils/constants";
import { useRouter } from "next/router";
import { useMemo } from "react";

export const useIsViewAsHR = () => {
  const authUser = useAuthStore.useUser();
  const router = useRouter();
  const groups = authUser?.profile?.["cognito:groups"];

  const isHR = useMemo(() => {
    if (
      (Array.isArray(groups) && groups.includes("Admin")) ||
      (typeof groups === "string" && groups.includes("Admin"))
    ) {
      return true;
    }
    return false;
  }, [groups]);

  const isViewAsHR = useMemo(() => {
    if (isHR && router.query?.view === "admin") return true;
    if (isHR && router.pathname === PAGE_URL.hr) return true;
    return false;
  }, [isHR, groups, router.query?.view]);

  const organizationGroup = groups?.find((group: string) =>
    group.startsWith("Org_")
  );

  return { isViewAsHR, isHR, organizationGroup, groups };
};
